"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M11.124 2v7.919l-3.375-2.7L6.5 8.781 10.524 12 6.5 15.219l1.249 1.562 3.375-2.7V22l7.6-6.001L13.725 12l4.999-4.001L11.124 2Zm2.001 4 2.399 1.999-2.399 1.92V6Zm0 8.081 2.399 1.918-2.399 1.92v-3.838Z", clipRule: "evenodd" })), 'BluetoothIcon');
